export default __webpack_public_path__ + "static/media/background_rainbow.69fd8a43.jpg";